unit AgentSelect;

interface

uses
  System.SysUtils,
  System.Classes,
{$IFDEF PAS2JS}
  Generics.Collections,
{$ELSE}
  System.Generics.Collections,
{$ENDIF}
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  WEBLib.StdCtrls,
  Vcl.StdCtrls,
  GA.Return.Types,
  Data.DB,
  WEBLib.DB,
  WEBLib.CDS,
  WEBLib.Grids,
  WEBLib.DBCtrls, WEBLib.ExtCtrls;

type
  TAgentSelectionForm = class(TForm)
    AddCharity: TLabel;
    UserManagement: TLabel;
    ClientTable: TDBTableControl;
    Clients: TClientDataSet;
    ClientSource: TDataSource;
    ClientsTenantId: TStringField;
    ClientsId: TIntegerField;
    ClientsName: TStringField;
    LogOutButton: TButton;
    Refresh: TTimer;
    procedure AddCharityClick(Sender: TObject);
    procedure ClientTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure LogOutButtonClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormDestroy(Sender: TObject);
    procedure RefreshTimer(Sender: TObject);
  private
    { Private declarations }
    FAgentId: integer;
    [async]
    procedure GetClientList; async;
    procedure AddRowActions(const ARecordId: Integer; AParentElement: TJSHTMLElement);
    procedure SelectCharity(const Id: Integer);
    procedure RefreshAgents;
  public
    { Public declarations }
    class procedure DisplayPage(const AElementId: string);
    [async]
    procedure InitForm; async;
    [async]
    procedure AddCharityToAgent; async;
    property AgentId: integer read FAgentId write FAgentId;
  protected procedure LoadDFMValues; override; end;

var
  AgentSelectionForm: TAgentSelectionForm;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  WEBLib.WebCtrls,
  MainDataModule,
  MainForm,
  SMX.Web.Layout.Utils,
  AgentRegisterClient;

procedure TAgentSelectionForm.AddCharityClick(Sender: TObject);
begin
  { TODO : Open AgentRegisterClient as popup }
  AddCharityToAgent;
end;

procedure TAgentSelectionForm.AddRowActions(const ARecordId: Integer; AParentElement: TJSHTMLElement);

  procedure SelectClick(Sender: TObject);
  begin
    SelectCharity(ARecordId);
  end;

var
  Span: THTMLSpan;
begin
{ TODO : choose better icon }
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-sign-in', 'Select');
  Span.OnClick := @SelectClick;
end;

procedure TAgentSelectionForm.ClientTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField;
  AValue: string; AElement: TJSHTMLElementRecord);
begin
  if ARow = 0 then
    Exit;

  if ACol = 0 then
  begin
    AddRowActions(ClientsId.Value, AElement.Element);
  end;

end;

procedure TAgentSelectionForm.WebFormDestroy(Sender: TObject);
begin
  Clients.Close;
end;

{ TAgentSelectionForm }

class procedure TAgentSelectionForm.DisplayPage(const AElementId: string);
  procedure AfterCreate(AForm: TObject);
  begin
    TAgentSelectionForm(AForm).InitForm;
  end;

begin
  if not Assigned(MainPage) then
  begin
    AgentSelectionForm := TAgentSelectionForm.CreateNew(AElementId, @AfterCreate);
  end

end;

procedure TAgentSelectionForm.GetClientList; {$IFDEF PAS2JS}async;{$ENDIF}
const
  svc_name = 'IAgentService.AvailableTenants';
var
  lRetval: TXDataClientResponse;
  lData: JS.TJSArray;
begin
  Clients.Active := True;
  Clients.EmptyDataSet;
  Clients.Active := False;
  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(svc_name, []));
  lData := TJSArray(lRetval.ResultAsObject['value']);
  Clients.Rows := lData;
  Clients.Active := True;
end;

procedure TAgentSelectionForm.InitForm; {$IFDEF PAS2JS}async;{$ENDIF}
begin
  AddCharity.Visible := not MainData.IsAdminOrganisation;
  UserManagement.Visible := not MainData.IsAdminOrganisation;
  await(GetClientList);
end;

procedure TAgentSelectionForm.LogOutButtonClick(Sender: TObject);
begin
  Close;
end;

procedure TAgentSelectionForm.SelectCharity(const Id: Integer);
var
  TenantId: string;
  OrganisationId: integer;
begin
  if not Clients.Locate('Id', Id, []) then
     Raise Exception.Create('Unable to find client');
  TenantId := ClientsTenantId.Value;

  if TenantId.IsEmpty then
     Raise Exception.Create('No TenantId specified');

  OrganisationId := ClientsId.Value;

  MainData.TenantId := TenantId;
  MainData.UserIsAgent := not MainData.IsAdminOrganisation;
  MainData.OrganisationId := OrganisationId;
  if MainData.IsAdminOrganisation then
    MainData.ShowMainPage
  else
    MainData.ShowAgentMainPage;

  { TODO : Open main page : should show selected tenant}

end;

procedure TAgentSelectionForm.WebFormClose(Sender: TObject; var Action:
    TCloseAction);
begin
  //Just in case it's still running
  Refresh.Enabled := False;
  Action := TCloseAction.caFree;
  MainData.Logout();
end;

procedure TAgentSelectionForm.AddCharityToAgent; {$IFDEF PAS2JS}async;{$ENDIF}
var
  AForm: TAgentClientForm;
begin
  AForm := TAgentClientForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());
    AForm.AgentId := MainData.AgentId;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
    Refresh.Enabled := True;
  end;
end;

procedure TAgentSelectionForm.RefreshTimer(Sender: TObject);
begin
  Refresh.Enabled := False;
  RefreshAgents;
end;

procedure TAgentSelectionForm.RefreshAgents;
begin
  GetClientList;
end;

procedure TAgentSelectionForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AddCharity := TLabel.Create('AddCharity');
  UserManagement := TLabel.Create(Self);
  ClientTable := TDBTableControl.Create(Self);
  LogOutButton := TButton.Create('logout-button');
  Clients := TClientDataSet.Create(Self);
  ClientsId := TIntegerField.Create(Self);
  ClientsTenantId := TStringField.Create(Self);
  ClientsName := TStringField.Create(Self);
  ClientSource := TDataSource.Create(Self);
  Refresh := TTimer.Create(Self);

  AddCharity.BeforeLoadDFMValues;
  UserManagement.BeforeLoadDFMValues;
  ClientTable.BeforeLoadDFMValues;
  LogOutButton.BeforeLoadDFMValues;
  Clients.BeforeLoadDFMValues;
  ClientsId.BeforeLoadDFMValues;
  ClientsTenantId.BeforeLoadDFMValues;
  ClientsName.BeforeLoadDFMValues;
  ClientSource.BeforeLoadDFMValues;
  Refresh.BeforeLoadDFMValues;
  try
    Name := 'AgentSelectionForm';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    AddCharity.SetParentComponent(Self);
    AddCharity.Name := 'AddCharity';
    AddCharity.Left := 56;
    AddCharity.Top := 240;
    AddCharity.Width := 94;
    AddCharity.Height := 25;
    AddCharity.Caption := 'Add Charity';
    AddCharity.ElementLabelClassName := 'btn btn-light';
    AddCharity.HeightPercent := 100.000000000000000000;
    AddCharity.WidthPercent := 100.000000000000000000;
    SetEvent(AddCharity, Self, 'OnClick', 'AddCharityClick');
    UserManagement.SetParentComponent(Self);
    UserManagement.Name := 'UserManagement';
    UserManagement.Left := 56;
    UserManagement.Top := 288;
    UserManagement.Width := 118;
    UserManagement.Height := 25;
    UserManagement.Caption := 'Manager Users';
    UserManagement.HeightPercent := 100.000000000000000000;
    UserManagement.Visible := False;
    UserManagement.WidthPercent := 100.000000000000000000;
    ClientTable.SetParentComponent(Self);
    ClientTable.Name := 'ClientTable';
    ClientTable.Left := 232;
    ClientTable.Top := 64;
    ClientTable.Width := 300;
    ClientTable.Height := 200;
    ClientTable.HeightStyle := ssAuto;
    ClientTable.BorderColor := clSilver;
    ClientTable.ChildOrder := 2;
    ClientTable.ElementFont := efCSS;
    ClientTable.ElementHeaderClassName := 'thead-light';
    ClientTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    ClientTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    ClientTable.Footer.ButtonElementClassName := 'btn btn-light';
    ClientTable.Footer.DropDownElementClassName := 'form-control';
    ClientTable.Footer.InputElementClassName := 'form-control';
    ClientTable.Footer.LinkActiveElementClassName := 'link-primary';
    ClientTable.Footer.LinkElementClassName := 'link-secondary';
    ClientTable.Footer.ListElementClassName := 'pagination';
    ClientTable.Footer.ListItemElementClassName := 'page-item';
    ClientTable.Footer.ListLinkElementClassName := 'page-link';
    ClientTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    ClientTable.Header.ButtonElementClassName := 'btn btn-light';
    ClientTable.Header.DropDownElementClassName := 'form-control';
    ClientTable.Header.InputElementClassName := 'form-control';
    ClientTable.Header.LinkActiveElementClassName := 'link-primary';
    ClientTable.Header.LinkElementClassName := 'link-secondary';
    ClientTable.Header.ListElementClassName := 'pagination';
    ClientTable.Header.ListItemElementClassName := 'page-item';
    ClientTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(ClientTable, Self, 'OnGetCellChildren', 'ClientTableGetCellChildren');
    ClientTable.Columns.Clear;
    with ClientTable.Columns.Add do
    begin
      DataField := 'Name';
      Title := 'Name';
    end;
    with ClientTable.Columns.Add do
    begin
      Title := ' ';
    end;
    ClientTable.DataSource := ClientSource;
    LogOutButton.SetParentComponent(Self);
    LogOutButton.Name := 'LogOutButton';
    LogOutButton.Left := 56;
    LogOutButton.Top := 320;
    LogOutButton.Width := 96;
    LogOutButton.Height := 25;
    LogOutButton.Caption := 'Log Out';
    LogOutButton.ChildOrder := 3;
    LogOutButton.ElementClassName := 'btn btn-primary';
    LogOutButton.ElementFont := efCSS;
    LogOutButton.ElementPosition := epIgnore;
    LogOutButton.HeightStyle := ssAuto;
    LogOutButton.HeightPercent := 100.000000000000000000;
    LogOutButton.WidthStyle := ssAuto;
    LogOutButton.WidthPercent := 100.000000000000000000;
    SetEvent(LogOutButton, Self, 'OnClick', 'LogOutButtonClick');
    Clients.SetParentComponent(Self);
    Clients.Name := 'Clients';
    Clients.Left := 64;
    Clients.Top := 72;
    ClientsId.SetParentComponent(Clients);
    ClientsId.Name := 'ClientsId';
    ClientsId.FieldName := 'Id';
    ClientsTenantId.SetParentComponent(Clients);
    ClientsTenantId.Name := 'ClientsTenantId';
    ClientsTenantId.FieldName := 'TenantId';
    ClientsTenantId.Size := 36;
    ClientsName.SetParentComponent(Clients);
    ClientsName.Name := 'ClientsName';
    ClientsName.FieldName := 'Name';
    ClientsName.Size := 250;
    ClientSource.SetParentComponent(Self);
    ClientSource.Name := 'ClientSource';
    ClientSource.DataSet := Clients;
    ClientSource.Left := 64;
    ClientSource.Top := 144;
    Refresh.SetParentComponent(Self);
    Refresh.Name := 'Refresh';
    Refresh.Enabled := False;
    Refresh.Interval := 10000;
    SetEvent(Refresh, Self, 'OnTimer', 'RefreshTimer');
    Refresh.Left := 296;
    Refresh.Top := 288;
  finally
    AddCharity.AfterLoadDFMValues;
    UserManagement.AfterLoadDFMValues;
    ClientTable.AfterLoadDFMValues;
    LogOutButton.AfterLoadDFMValues;
    Clients.AfterLoadDFMValues;
    ClientsId.AfterLoadDFMValues;
    ClientsTenantId.AfterLoadDFMValues;
    ClientsName.AfterLoadDFMValues;
    ClientSource.AfterLoadDFMValues;
    Refresh.AfterLoadDFMValues;
  end;
end;

end.
